/**
 * Environment variables configuration
 * All API URLs are read from .env file
 * All requests go through the API Gateway - no direct API access
 */

// Gateway base URL - all API requests must go through gateway
// Local default is the dev Gateway (YARP) port. Override via VITE_API_GATEWAY_URL.
const gatewayBaseUrl = import.meta.env.VITE_API_GATEWAY_URL || 'http://localhost:5000';

export const env = {
  // Base API URL - Gateway endpoint
  apiBaseUrl: `${gatewayBaseUrl}/api`,
  
  // Service-specific API URLs - All through Gateway
  authApiUrl: `${gatewayBaseUrl}/api/auth`,
  hrApiUrl: `${gatewayBaseUrl}/api/hr`,
  financeApiUrl: `${gatewayBaseUrl}/api/finance`,
  crmApiUrl: `${gatewayBaseUrl}/api/crm`,
  projectApiUrl: `${gatewayBaseUrl}/api/project`,
  workflowApiUrl: `${gatewayBaseUrl}/api/workflow`,
  documentApiUrl: `${gatewayBaseUrl}/api/document`,
  portalApiUrl: `${gatewayBaseUrl}/api/portal`,
  
  // Environment
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  mode: import.meta.env.MODE,
} as const

